import { AdProps, AdType, ComponentType, AdPlacementType } from '@sport1/types/web'

//TODO: change ad placement type to stroer ad placement type MREC -> RECTANGLE , check if it is used only on desktop
export const getAd = (adKeywords: string[]): AdProps => {
    return {
        type: ComponentType.AD,
        ad: {
            placement: AdPlacementType.MREC,
            adType: AdType.DISPLAY,
            adKeys: adKeywords,
        },
    }
}

export const getOutbrainAd = (): AdProps => {
    return {
        type: ComponentType.AD,
        ad: {
            placement: AdPlacementType.ARTICLE_SIDE_COLUMN_AD,
            adType: AdType.OUTBRAIN_AD,
            widgetIdentifiers: {
                web: 'SB_1',
            },
            adKeys: [],
        },
    }
}
